import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 999;
  overflow: auto;
  flex-direction: column;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const Title = styled(Box)`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #000000;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const TitleContainer = styled(Flex)`
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  justify-content: space-between;
  margin-bottom: 8px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  outline: none;
`;

export const Popup = ({
  children,
  isShown,
  title,
  handleClose,
}: {
  children: React.ReactNode;
  isShown: boolean;
  title: string;
  handleClose?: () => void;
}): ReactElement | null => {
  if (!isShown) return null;
  return (
    <Container>
      <TitleContainer>
        <Title>{title}</Title>
        <CloseButton onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </TitleContainer>
      {children}
    </Container>
  );
};
